<template>
  <transition name="fade" mode="out-in">
    <div class="home" v-smoothscroll="{ duration : 500 }">
      <homeEntry></homeEntry>
      <homeEmployeeHighlight></homeEmployeeHighlight>
      <homeAbout></homeAbout>
      <homeServices></homeServices>
      <homeTeam></homeTeam>
    </div>
  </transition>
</template>

<script>

export default {

}

</script>
